import ActionTypes from './actionTypes';

export function fetchNotifications() {
  return {
    type: ActionTypes.NOTIFICATIONS.FETCH.REQUEST,
  };
}

export function fetchNotificationsSuccess(notifications) {
  return {
    type: ActionTypes.NOTIFICATIONS.FETCH.SUCCESS,
    payload: {
      notifications,
    },
  };
}

export function fetchNotificationsFailure() {
  return {
    type: ActionTypes.NOTIFICATIONS.FETCH.FAILURE,
  };
}

export function markNotificationsRead(notificationId,isRead) {
  let updateNotificationRequest = JSON.stringify({
    isRead: isRead
  });
  return {
    type: ActionTypes.NOTIFICATIONS.MARK_AS_READ.REQUEST,
    payload: {
      notificationId,
      updateNotificationRequest
    }
  };
}

export function markNotificationsReadSuccess(notificationId) {
  return {
    type: ActionTypes.NOTIFICATIONS.MARK_AS_READ.SUCCESS,
    payload: {
      notificationId,
    }
  };
}

export function markNotificationsReadFailure() {
  return {
    type: ActionTypes.NOTIFICATIONS.MARK_AS_READ.FAILURE,
  };
}
